import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconBadgeComponent } from './icon-badge.component';

/**
 * Module that provides the fontawesome icon components.
 *
 * This module provides only the components and providers for
 * using the icons. To actually make icons available either
 * - use the `FaIconLibrary`
 * - use `FmntsDefaultIconsLib` in the app module
 */
@NgModule({
  imports: [FontAwesomeModule, IconBadgeComponent],
  exports: [FontAwesomeModule, IconBadgeComponent],
})
export class FmntsIconsModule {}
